import { render, staticRenderFns } from "./TrialStepDownloadWindows.vue?vue&type=template&id=03aaf470&scoped=true&"
import script from "./TrialStepDownloadWindows.vue?vue&type=script&lang=ts&"
export * from "./TrialStepDownloadWindows.vue?vue&type=script&lang=ts&"
import style0 from "./TrialStepDownloadWindows.vue?vue&type=style&index=0&id=03aaf470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aaf470",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03aaf470')) {
      api.createRecord('03aaf470', component.options)
    } else {
      api.reload('03aaf470', component.options)
    }
    module.hot.accept("./TrialStepDownloadWindows.vue?vue&type=template&id=03aaf470&scoped=true&", function () {
      api.rerender('03aaf470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/trial/TrialStepDownloadWindows.vue"
export default component.exports